import React from "react";

const ExtrapayTable = ({ columns, rows, emptyMessage, rowKey }) => (
  <div className="overflow-auto">
    <table className="w-full" style={{ borderCollapse: "collapse", borderSpacing: "0 10px" }}>
      <thead>
        <tr style={{ backgroundColor: "#F7F8FA" }}>
          {columns.map((column, idx) => {
            const isFirst = idx === 0;
            const isLast = idx === columns.length - 1;
            return (
              <th
                key={column.key}
                className={`text-left text-sm font-medium p-3${isFirst ? " border-round-left-md" : ""}${isLast ? " border-round-right-md" : ""}`}
                style={{
                  color: "var(--theme-text-muted, #5C5C5C)",
                }}
              >
                {column.header}
              </th>
            );
          })}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => {
          const isFirst = idx === 0;
          const isLast = idx === rows.length - 1;
          return (
            <tr
              key={rowKey(row)}
              style={{
                borderTop: isFirst ? "none" : "1px solid var(--theme-border, #EBEBEB)",
                borderBottom: isLast ? "none" : "1px solid var(--theme-border, #EBEBEB)",
              }}
            >
              {columns.map((column) => (
                <td
                  key={column.key}
                  className={`${isFirst ? "p-3 pt-4" : "p-3"} text-sm`}
                  style={{ color: "var(--theme-text)" }}
                >
                  {column.render(row)}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default ExtrapayTable;
